<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Calificaciones Promedios</h6>
                </v-card-title>
                <v-card-text class="pt-2">
                    <v-row dense>
                        <v-col cols="6" sm="6" md="3">
                            <v-text-field label="Filtro por Año" dense v-model="filtroperiodo">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="1">
                            <v-text-field label="Valor de Referencia" suffix="%" dense v-model="referencia">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" sm="6" md="3">
                            <v-btn tile color="success" @click="cargarpromgeneral()">
                                <v-icon left> mdi-magnify </v-icon>
                                Buscar
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card>
                <v-card-text>
                    <table border="1" cellspacing="1" width="64%" id="AutoNumber1">
                        <tr>
                            <td width="50%" bgcolor="#FFFF99">
                                <font face="Arial" size="2">&nbsp;</font>
                            </td>
                            <td width="25%" bgcolor="#FFFF99" align="center">
                                <font face="Arial" size="2">&nbsp;Año: {{ periodoant }}
                                </font>
                            </td>
                            <td width="25%" bgcolor="#FFFF99" align="center">
                                <font face="Arial" size="2">&nbsp;Año: {{ periodo }}
                                </font>
                            </td>
                        </tr>
                        <tr>
                            <td width="50%" bgcolor="#FFFF99">
                                <font face="Arial" size="2">Promedio General</font>
                            </td>
                            <td width="25%" bgcolor="#FFFF99" align="center">
                                <v-btn :class="colorcelda(promgralperiodoant)" class="font-class-name2"
                                    @click="cargarListados(periodoant, '')">
                                    {{ promgralperiodoant }} %</v-btn>

                            </td>
                            <td width="25%" bgcolor="#FFFF99" align="center">
                                <v-btn :class="colorcelda(promgralperiodo, '')" class="font-class-name2"
                                    @click="cargarListados(periodo)">
                                    {{ promgralperiodo }} %</v-btn>
                            </td>
                        </tr>
                    </table>
                </v-card-text>
            </v-card>
            <v-card>
                <v-card-text>
                    <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                        :items-per-page="200" v-if="listado.length > 0" hide-default-footer>
                        <template v-slot:item.puntaje1="{ item }">
                            <td>
                                <v-btn :class="colorcelda(item.puntaje1)" class="font-class-name2"
                                    @click="cargarListados(periodoant, item.gerencia)">
                                    {{ item.puntaje1 }} %</v-btn>
                            </td>
                        </template>
                        <template v-slot:item.puntaje2="{ item }">
                            <td>
                                <v-btn :class="colorcelda(item.puntaje2)" class="font-class-name2"
                                    @click="cargarListados(periodo, item.gerencia)">
                                    {{ item.puntaje2 }} %</v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <v-card>
                <v-card-text>
                    <v-data-table dense :headers="headersL" :items="listadoL" locale="es-ar" class="elevation-1"
                        :items-per-page="200" v-if="listadoL.length > 0" hide-default-footer>
                        <template v-slot:top>
                            <v-toolbar flat dense>
                                <v-toolbar-title center>
                                    <font color="green">{{ titulogerencia }} </font>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.puntaje1="{ item }">
                            <td>
                                <v-btn :class="colorcelda(item.puntaje1)" class="font-class-name2"
                                    @click="cargarListadosR(item.periodo, item.legajo)">
                                    {{ item.puntaje1 }} %</v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <v-card>
                <v-card-text>
                    <v-data-table dense :headers="headersR" :items="listadoR" locale="es-ar" class="elevation-1"
                        :items-per-page="2000" v-if="listadoR.length > 0" hide-default-footer>
                        <template v-slot:top>
                            <v-toolbar flat dense>
                                <v-toolbar-title center>
                                    <font color="green">{{ titulolegajo }} - {{ titulonombre }}</font>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.codgral="{ item }">
                            <v-chip @click="verRegistro(item)">
                                {{ item.codgral }}
                            </v-chip> - {{ item.tema }}
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <VerRegistro :visible="showRegistro" :codgral="editedItem.codgral" @close="showRegistro = false">
            </VerRegistro>
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import VerRegistro from "../Capacitaciones/Informeregistro.vue"
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    components: { VerRegistro },
    data: (vm) => ({
        showRegistro: false,
        editedItem: {},
        editedIndex: -1,
        filtroestado: "Todos",
        filtroperiodo: moment().format("YYYY"),
        referencia: "0",
        periodo: "",
        periodoant: "",
        promgralperiodo: "",
        promgralperiodoant: "",
        listado: [],
        listadoL: [],
        listadoR: [],
        titulolegajo: "",
        titulonombre: "",
        titulogerencia: "",
        headers: [
            {
                text: "Sector",
                align: "center",
                sortable: false,
                value: "gerencia",
            },
            { text: "Promedio", value: "puntaje1", sortable: false },
            { text: "Promedio", value: "puntaje2", sortable: false },
        ],
        headersL: [
            { text: "Legajo", value: "legajo", sortable: false },
            { text: "Nombre", value: "nombre", sortable: false },
            { text: "Sector", align: "center", sortable: false, value: "gerencia" },
            { text: "Promedio", value: "puntaje1", sortable: false },
        ],
        headersR: [
            { text: "Capacitación", value: "curso", sortable: false },
            { text: "Registro", value: "codgral", sortable: false },
            { text: "Puntaje", align: "center", sortable: false, value: "puntaje" },
            { text: "Observaciones", value: "observ", sortable: false },
        ],
    }),
    computed: {
        show: {
            get() {
                // this.cargarpromgeneral();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        cargarpromgeneral() {
            const periodo = this.filtroperiodo;
            let self = this;

            axios
                .get("/RRHH/CargarPromCalif?", {
                    params: {
                        filtroperiodo: periodo,
                    },
                })
                .then((response) => {
                    self.promgralperiodo = response.data.item2;
                    self.promgralperiodoant = response.data.item1;
                    self.periodo = self.filtroperiodo;
                    self.periodoant = parseInt(self.filtroperiodo) - 1;
                    console.log("PROMANT ", response.data)
                })
                .catch((error) => {
                    console.log(error);
                });


            axios
                .get("/RRHH/CargarPromCalifSector?", {
                    params: {
                        filtroperiodo: periodo,
                    },
                })
                .then((response) => {
                    self.listado = response.data;
                    self.listadoR = [];
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        colorcelda(item) {
            if (parseFloat(item) < parseFloat(this.referencia)) {
                return "red"
            }
            else {
                return "green"
            }
        },

        cargarListados(periodo, gerencia) {
            //const periodo = periodo;
            let self = this;

            axios
                .get("/RRHH/CargarPromedioPorLegajo?", {
                    params: {
                        filtroperiodo: periodo,
                        filtrogerencia: gerencia,
                    },
                })
                .then((response) => {
                    self.listadoR = [];
                    self.listadoL = response.data;
                    if (gerencia != null && gerencia != "") {
                        self.titulogerencia = gerencia;
                    }
                    else {
                        self.titulogerencia = "General";
                    }
                })
                .catch((error) => {
                    self.listadoR = [];
                    self.listadoL = [];
                    console.log(error);
                });
        },

        cargarListadosR(periodo, legajo) {
            //const periodo = periodo;
            let self = this;
            console.log("LEGAJO ", legajo)
            axios
                .get("/RRHH/CargarDetallePorLegajo?", {
                    params: {
                        filtroperiodo: periodo,
                        legajo: legajo,
                    },
                })
                .then((response) => {
                    self.listadoR = response.data;
                    self.titulolegajo = response.data[0].legajo;
                    self.titulonombre = response.data[0].nombre;
                })
                .catch((error) => {
                    self.listadoR = [];
                    console.log(error);
                });
        },

        vaciarModels() {
            this.listado = [];
        },

        verRegistro(item) {
            this.editedIndex = this.listadoR.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showRegistro = true;
        },
    },
};
</script>